import './dataSyncCtrl';
import './error';
import './mobile';
import './routing';
import './uploadCtrl';